const comments = [
  {
    name: '吃瓜不嫌事大',
    avatar: 'R',
    time: '3分钟前',
    content: '黑料网下载真的太牛了！更新速度全网第一，每次都是第一时间能看到最新爆料，而且画质贼清晰。现在看黑料视频在线播放只认这家！',
    likes: 238,
  },
  {
    name: '娱乐追踪者',
    avatar: '追',
    time: '28分钟前',
    content: '以前看黑料在线观看还得下载各种APP，现在直接在黑料网上就能看，方便太多了。手机端体验也很好，强烈推荐黑料在线看片的兄弟们来这儿！',
    likes: 186,
  },
  {
    name: '深夜吃瓜人',
    avatar: '瓜',
    time: '1小时前',
    content: '说实话黑料网在线观看的资源是真的全，有些独家内容别的地方根本找不到。而且一直稳定更新，每天都有新瓜可以吃，太爽了。',
    likes: 421,
  },
  {
    name: '八卦第一线',
    avatar: '线',
    time: '2小时前',
    content: '作为一个资深吃瓜群众，我逛过不下二十个同类站，黑料网下载的内容质量和更新频率绝对排前三。黑料视频在线播放非常流畅，从来没卡过。',
    likes: 157,
  },
  {
    name: '瓜田里的猹',
    avatar: '猹',
    time: '4小时前',
    content: '黑料在线观看这一块真的是良心站！不用注册不用登录，打开就能看，还没有乱七八糟的弹窗广告。已经推荐给身边所有爱吃瓜的朋友了！',
    likes: 312,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-chat-smile-2-line"></i>
            用户评价
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            吃瓜群众都在说
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            来自真实用户的观看体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((c, i) => (
            <div
              key={i}
              className={`bg-background-50 border border-secondary-200/60 rounded-xl p-5 md:p-6 ${
                i === 2 ? 'lg:col-span-2 md:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="text-sm font-bold text-primary-600">{c.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-800">{c.name}</span>
                    <span className="text-xs text-foreground-400">{c.time}</span>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-accent-500">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-xs"></i>
                  ))}
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {c.content}
              </p>
              <div className="flex items-center gap-4 mt-3 pt-3 border-t border-secondary-100">
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-thumb-up-line"></i>
                  {c.likes}
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-chat-1-line"></i>
                  回复
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-share-line"></i>
                  分享
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}